<template>
    <Loading :loading="loading" :inset="true" :text="$t('plain_register') + '...'">
        <form @submit.prevent="register()" class="relative flex flex-col">
            <Input type="text" name="email" :formComponentId="this.$.uid" :label="$t('email_adress') + '*'" v-model:value="user.email" autocomplete="email"> </Input>
            <Input
                type="text"
                name="email_confirmation"
                :formComponentId="this.$.uid"
                :label="$t('confirm_mail') + '*'"
                v-model:value="user.email_confirmation"
                :preventinsert="true"
                autocomplete="new-password"
            >
            </Input>
            <Input
                type="password"
                name="password"
                :formComponentId="this.$.uid"
                :label="$t('account_password') + '*'"
                v-model:value="user.password"
                autocomplete="new-password"
                :strengthMeter="true"
                :preventinsert="true"
            >
            </Input>
            <Input
                type="password"
                name="password_confirmation"
                :formComponentId="this.$.uid"
                :passwordCheck="user.password"
                :label="$t('confirm_password') + '*'"
                v-model:value="user.password_confirmation"
                :strengthMeter="true"
                :preventinsert="true"
            >
            </Input>

            <div v-if="showLinks">
                <router-link :to="{ name: 'login' }" class="block underline mt-2">
                    {{ $t('account_state_true') }}
                </router-link>
            </div>

            <slot name="section-1"></slot>

            <FormButton type="submit" class="my-6" :formComponentId="this.$.uid" styling="primary flex items-center gap-3" :value="$t('plain_register')" :disabled="loading">
                <transition name="fade">
                    <FontAwesomeIcon v-show="loading" :icon="['fas', 'circle-notch']" class="animate-spin text-white transition-all ease-in-out duration-300"></FontAwesomeIcon>
                </transition>
            </FormButton>

            <slot name="section-2"></slot>
        </form>
    </Loading>
</template>

<script>
import { getActiveLanguage } from 'laravel-vue-i18n';

export default {
    props: {
        showLinks: Boolean
    },

    mounted() {
        this.user.language = getActiveLanguage();
    },

    data: () => ({
        loading: false,
        user: {}
    }),

    methods: {
        register() {
            this.$store.commit('error/unsetByComponentId', this.$.uid);
            this.loading = true;
            this.user.config = { componentId: this.$.uid };
            this.$store
                .dispatch('user/register', this.user)
                .then(() => {
                    this.loading = false;
                    this.$router.push('/dashboard');
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
